// Apollo's refetch() and client.refetchQueries() return a promise that REJECTS when the request
// fails. Called fire-and-forget (a Retry button, a refresh after a mutation) that rejection would
// go unhandled. The query's own `error` state already shows the failure on screen, so the promise
// is only swallowed here.
export function refetchQuietly(
  request: { catch: (onRejected: () => void) => unknown } | undefined,
) {
  request?.catch(() => {})
}
